import { useCallback, useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { api } from "../lib/api";
import { Overview } from "../components/admin/Overview";
import { Composer } from "../components/admin/Composer";
import { Inbox } from "../components/admin/Inbox";
import { Members, Tips } from "../components/admin/Tables";
import { Testers } from "../components/admin/Testers";
import { PostCard } from "../components/feed/PostCard";

const TABS = [["overview", "Overview"], ["create", "New post"], ["posts", "Posts"], ["inbox", "Inbox"], ["members", "Members"], ["tips", "Tips"], ["testers", "Testers"]];

export default function Studio() {
  const [tab, setTab] = useState("overview");
  const [stats, setStats] = useState(null);
  const [posts, setPosts] = useState([]);

  const loadStats = useCallback(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);
  const loadPosts = useCallback(() => {
    api.get("/posts").then((r) => setPosts(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);

  useEffect(() => {
    loadStats();
    loadPosts();
  }, [loadStats, loadPosts]);

  return (
    <main data-testid="studio-page" className="max-w-[1300px] mx-auto px-4 sm:px-8 pt-[110px] pb-24">
      <p className="eyebrow mb-4">Creator studio</p>
      <h1 className="font-display text-4xl sm:text-5xl text-[#0E1B3D]">Hello, <span className="italic text-[#D7263D]">Katie.</span></h1>
      <Tabs value={tab} onValueChange={setTab} className="mt-10">
        <TabsList className="bg-transparent border-b border-[#0E1B3D]/10 rounded-none w-full justify-start h-auto p-0 gap-1 overflow-x-auto">
          {TABS.map(([k, l]) => (
            <TabsTrigger key={k} value={k} data-testid={`studio-tab-${k}`}
              className="rounded-none px-4 py-3 text-xs tracking-[0.14em] uppercase text-[#4A5878] data-[state=active]:bg-transparent data-[state=active]:text-[#D7263D] data-[state=active]:shadow-none data-[state=active]:border-b-2 data-[state=active]:border-[#D7263D]">
              {l}{k === "inbox" && stats?.unread_messages ? ` (${stats.unread_messages})` : ""}
            </TabsTrigger>
          ))}
        </TabsList>
        <div className="mt-8">
          <TabsContent value="overview"><Overview stats={stats} /></TabsContent>
          <TabsContent value="create"><Composer onPublished={() => { loadPosts(); loadStats(); setTab("posts"); }} /></TabsContent>
          <TabsContent value="posts">
            <div data-testid="studio-posts-list" className="grid md:grid-cols-2 gap-6 items-start">
              {posts.map((p) => <PostCard key={p.id} post={p} isAdmin onTip={() => {}} onDeleted={(id) => { setPosts((ps) => ps.filter((x) => x.id !== id)); loadStats(); }} />)}
            </div>
          </TabsContent>
          <TabsContent value="inbox"><Inbox onRead={loadStats} /></TabsContent>
          <TabsContent value="members"><Members /></TabsContent>
          <TabsContent value="tips"><Tips /></TabsContent>
          <TabsContent value="testers"><Testers onRan={() => { loadStats(); loadPosts(); }} /></TabsContent>
        </div>
      </Tabs>
    </main>
  );
}
